import { enc } from './core.js';
export function membershipsApi(c) {
    return {
        list: (localId) => c.get(`/locals/${enc(localId)}/members`),
        add: (localId, body) => c.post(`/locals/${enc(localId)}/members`, body),
        remove: (localId, membershipId) => c.delete(`/locals/${enc(localId)}/members/${enc(membershipId)}`),
    };
}
//# sourceMappingURL=memberships.js.map